import React from 'react';

import MuiAccordion, {
  AccordionProps as MuiAccordionProps,
} from '@mui/material/Accordion';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const Accordion = withCoreProps<AccordionProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<AccordionProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiAccordion {...props} className={clsxClass}>
        {children}
      </MuiAccordion>
    );
  },
);

export interface AccordionProps extends MuiAccordionProps, CoreProps {}
